import React from "react"
import "./Badge.css"

const Badge = ({ children, className = "", variant = "default" }) => {
  return <span className={`badge badge-${variant} ${className}`}>{children}</span>
}

export default Badge
